export default {"src":"/_next/static/media/loading.a3261430.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};